import { render, staticRenderFns } from "./CommonWidgetHeader.vue?vue&type=template&id=5cf2785c"
import script from "./CommonWidgetHeader.vue?vue&type=script&lang=js"
export * from "./CommonWidgetHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports